import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SurveyRequest } from '../../../../../app/profile/models/onboarding.model';
import { validateAllFormFields } from '../../../../../app/shared/utils/utils';
import { ActivatedRoute } from '@angular/router';
import { OnboardingService } from '../../../../../app/profile/services/onboarding.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { I18nService } from '../../../../../app/shared/services/i18n.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {
  surveyForm: FormGroup;
  supplierCode: string;
  surveyCompleted: boolean = false;
  value: Observable<number>;

  get SurveyControls() {
    return {
      Comments: this.surveyForm.get('Comments'),
      Rating: this.surveyForm.get('Rating')
    }
  }
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private onboardingService: OnboardingService,
    private snackBar: MatSnackBar,
    private translateService: I18nService,
  ) { }

  ngOnInit(): void {
    //  Get supplier code from route
    this.supplierCode = this.route.snapshot.params['code'];
    this.onboardingService.getSurvey(this.supplierCode)
        .subscribe(result => {
          // If supplier already submitted the survey set the completion flag to true.
          if(result != undefined && result != null){
            this.surveyCompleted = true;
          }
        });

    this.surveyForm = this.fb.group({
      Comments: [null],
      Rating: [null, Validators.required]
    });
    this.value = this.SurveyControls.Rating.valueChanges;
  }

  saveSurvey(){
    if(this.surveyForm.valid){
      const surveyRequest = new SurveyRequest()
      surveyRequest.Rating = this.SurveyControls.Rating.value;
      surveyRequest.Comments = this.SurveyControls.Comments.value;
      surveyRequest.SupplierCode = this.supplierCode;
      this.onboardingService.postSurvey(surveyRequest)
          .subscribe(result => {
            this.surveyCompleted = true;
          }, (error) => {
            this.snackBar.open(this.translateService.get("Something went wrong!"), null, {
              duration: 5000,
              verticalPosition: 'top',
              panelClass: ['red-snackbar']
            });
          });
    }else{
      validateAllFormFields(this.surveyForm);
    }
  }
}
